import "./index.scss";
import logo1 from "@src/assets/image/logo1.png";

const Footer = () => {
  return (
    <div className="layout-footer-wrapper">
      <div className="footer_content">
        <img className="footer_logo" src={logo1} alt="" />
      </div>
    </div>
  );
}

export default Footer;